import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuardService } from '../../core/core.module';
import { PraticheComponent } from './pratiche/pratiche.component';
import { PraticaComponent } from './pratica/pratica.component';
import { DettagliComponent } from './pratica/dettagli/dettagli.component';
import { DocumentiComponent } from './pratica/documenti/documenti.component';
import { NoteComponent } from './pratica/note/note.component';
import { RateComponent } from './pratica/rate/rate.component';
import { QuestionarioComponent } from './pratica/questionario/questionario.component';

const routes: Routes = [
  {
    path: '',
    component: PraticheComponent,
    canActivate: [AuthGuardService],
    data: { title: 'Pratiche' }
  },
  {
    path: 'pratica/:id',
    component: PraticaComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        redirectTo: 'dettagli',
        pathMatch: 'full'
      },
      {
        path: 'dettagli',
        component: DettagliComponent,
        data: { title: 'Dettagli' }
      },
      {
        path: 'documenti',
        component: DocumentiComponent,
        data: { title: 'Documenti' }
      },
      {
        path: 'note',
        component: NoteComponent,
        data: { title: 'Note' }
      },
      {
        path: 'questionario',
        component: QuestionarioComponent,
        data: { title: 'Questionario' }
      },
      {
        path: 'rate',
        component: RateComponent,
        data: { title: 'Rate' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PraticheRoutingModule {}
